import __base_store from '@/store/__base_store'

/**
 * Store de estados de orden de Tienda Nube.
 */
export default __base_store({
	state: {
		model_name: 'tienda_nube_order_status',
	},
})

